import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-content',
  template: `
    <h2 mat-dialog-title>{{ getTitle() }}</h2>
    <div mat-dialog-content>
      @if (data.type === 'Electronic Communication Terms') {
        <h1>THIS IS A PLACEHOLDER TEXT</h1>
        <div class="terms-content">
          <p>By agreeing to these Electronic Communication Terms, you consent to receive all communications, 
          disclosures, notices, statements, and other documents related to your Transend Financial account electronically.</p>
          
          <h3>Electronic Delivery of Communications</h3>
          <p>You agree that we may provide all communications, disclosures, notices, statements, and other documents 
          related to your account electronically, either by posting them on our website, mobile application, 
          or by emailing them to the email address you have provided.</p>
          
          <h3>Hardware and Software Requirements</h3>
          <p>To access and retain electronic communications, you will need:</p>
          <ul>
            <li>A computer or mobile device with internet access</li>
            <li>A current web browser that supports 128-bit encryption</li>
            <li>An email account</li>
            <li>A printer or electronic storage device if you wish to print or save communications</li>
          </ul>
          
          <h3>Paper Copies</h3>
          <p>You have the right to request paper copies of any electronic communications we provide. 
          To request a paper copy, please contact our customer service department.</p>
          
          <h3>Withdrawing Consent</h3>
          <p>You have the right to withdraw your consent to receive electronic communications at any time. 
          To withdraw your consent, please contact our customer service department. If you withdraw your consent, 
          there may be consequences to your account, including possible fees or account restrictions.</p>
        </div>
      } @else if (data.type === 'US Patriot Act Disclosure') {
        <div class="terms-content">
          <h3>IMPORTANT INFORMATION ABOUT ESTABLISHING A NEW CUSTOMER RELATIONSHIP</h3>
          <p>To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies every customer.</p>
          
          <p><strong>What this means for you:</strong></p>
          <p>When you open an account, we will ask for your name, address, date of birth, social security number, and other information that will allow us to identify you. We may also ask to see your driver's license or other identifying documents.</p>
        </div>
      }
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
    </div>
  `,
  styles: [`
    .terms-content {
      max-height: 400px;
      overflow-y: auto;
    }
    h3 {
      margin-top: 16px;
      margin-bottom: 8px;
    }
    ul {
      margin-left: 20px;
    }
  `]
})
export class DialogContentComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { type: string },
    public dialogRef: MatDialogRef<DialogContentComponent>
  ) {}

  public getTitle(): string {
    return this.data.type || 'Information';
  }
}